import React, { useEffect, useState } from 'react';
import { Segment, Header, Pagination, Dropdown, Icon } from 'semantic-ui-react';

import { advertisingOrderBy } from '../../config/config';
import { useTranslation } from 'react-i18next';
import AdvertisingListItem from './advertisingListItem';

const AdvertisingList = ({show, pagination, onClickEdit, onChangeOrderBy, onSetPagination, advertisings, advertisingsOrderBy}) => {
  const {t} = useTranslation()
  const [data, setData] = useState();

  useEffect(() => {
    setData(advertisings);
  }, [advertisings]);
  
  if(!show)
    return null

  return(
    <section>
      <Header as='h2' attached='top' className={'background-blue'} style={{display: 'flex'}}>
        <Pagination
          activePage={pagination.activePage}
          onPageChange={onSetPagination}
          firstItem={null}
          lastItem={null} 
          pointing
          secondary
          inverted
          style={{borderColor: 'transparent'}}
          totalPages={pagination.totalPages}
        />
        <Dropdown 
          text={t('input-label-sortby', {sortby: t(`label-${advertisingsOrderBy}`)})}
          style={{marginRight: 0, marginLeft: 'auto'}}
        >
          <Dropdown.Menu>
            {advertisingOrderBy.map(element => (
              <Dropdown.Item key={element.key} value={element.value} text={t(element.text)} onClick={onChangeOrderBy}/>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Header>
      <Segment attached >
        {data && data.length > 0 ? data.map((element, index) => (
          renderAdvertisingsList(index, element, onClickEdit)
        )) :
          <Header as='h2' icon textAlign='center'>
            <Icon name='sticky note outline' color='blue' circular inverted />
            {t('headline-no_advertisings')}
            <Header.Subheader>
              {t('content-no_advertisings')}
            </Header.Subheader>
          </Header>
        }
      </Segment>
    </section>
  )
}

export default AdvertisingList

function renderAdvertisingsList(index, element, onClickEdit) {
  return <AdvertisingListItem
    key={index}
    id={element.id}
    title={element.title}
    subtitle={element.subtitle}
    isActive={element.isActive}
    startDate={element.startDate}
    endDate={element.endDate}
    onClickEdit={onClickEdit} />;
}
